// hooks/usePDFExport.js
import { 
  generateServicioCocinaReport, 
  generateServicioCocinaNacionalidadReport 
} from '../services/reportService';

export const usePDFExport = () => {
  
  const exportServicioCocina = async (data, totales,params2) => {        
    if (!data || data.length === 0) {
      throw new Error('No hay datos para exportar');
    }
    return await generateServicioCocinaReport(data, params2);
  };
  
  const exportServicioCocinaNacionalidad = async (data, totales, params2) => {
    if (!data || data.length === 0) {
      throw new Error('No hay datos para exportar');
    }
    return await generateServicioCocinaNacionalidadReport(data, params2);
  };
  
  return { exportServicioCocina, exportServicioCocinaNacionalidad };
};